/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_CompleteInputs */

const en_common_complete = /** @type {(inputs: Common_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete`)
};

/**
* | output |
* | --- |
* | "Complete" |
*
* @param {Common_CompleteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const common_complete = /** @type {((inputs?: Common_CompleteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_CompleteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_complete(inputs)
});